import LanguageMenu from 'components/LanguageMenu/LanguageMenu';

export default LanguageMenu;
